import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSettings } from '../hook/use_settings';
import { TitlePage } from './components/tabmenu/index';
import { useSessionStore } from '../context/session';
import { Messages } from '../constant/messages';

/**
 * 各画面表示用レイアウト
 * @param children
 * @constructor
 */
export const MainLayout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const settings = useSettings();
  const navigator = useNavigate();
  const { hasSession, selectedDivisionId, selectedFloorGroupId } = useSessionStore((state) => state);
  useEffect(() => {
    const token = sessionStorage.getItem('token');
    const token2 = window.session.token;
    if (token2 === undefined || token2 === null || token2 === '') {
      navigator('/login', { state: { message: Messages.ERR_401 } });
    }
    if (token === null) {
      sessionStorage.setItem('token', token2);
    } else if (token !== token2) {
      navigator('/login', { state: { message: Messages.ERR_401 } });
    }
  }, []);

  if (!hasSession || (selectedDivisionId === 0 || selectedFloorGroupId === 0)) {
    return <>{children}</>;
  }

  return (
    <div>
      <TitlePage height={settings.headerHeight} />
      <div style={{ marginTop: '70px' }}>{children}</div>
    </div>
  );
};
